import React from "react";

type H5Props = {
  children:  React.ReactElement | any;
  bold?: boolean;
  fontType?: string;
  color?: string;
  className?: string;
};
const H5: React.FC<H5Props> = ({
  children,
  bold,
  color = "text-blueishblack",
  fontType = "regular",
  className = "",
}): React.ReactElement => {
  const _fType = bold ? "bold" : fontType;

  return <h5 className={`text-xl ${color} ${className}`}>{children}</h5>;
};

export default H5;
